import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const videoStyle = ({ theme, color }: { theme: Theme; color?: string }) => css`
  border-radius: ${theme.spacing(2)};
  margin-top: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(2)};
  border: 1px solid ${color ?? theme.palette.primary.main}20;

  &::-webkit-media-controls-panel {
    background: linear-gradient(
      0deg,
      ${color ?? theme.palette.primary.main} 0%,
      ${color ?? theme.palette.primary.main}C0 20%,
      ${color ?? theme.palette.primary.main}00 40%
    );
  }
  &::-webkit-media-controls-time-remaining-display,
  &::-webkit-media-controls-current-time-display {
    display: none;
  }
`
